// Crypto: wallets, exchanges, tokens, DeFi, offerings
import {cdnUrl} from '@/util/cdnImage';
import type {PageHeadMeta} from '@/components/PageHead';

export const CRYPTO_WALLET_META_DATA: PageHeadMeta = {
    title: 'Cryptocurrency Wallet Development Company | Crypto Wallet Development Services',
    img: cdnUrl('crypto-wallet-icons/Cryptocurrency-Wallet-Development-Company.jpg'),
    description:
        'Experience top-tier cryptocurrency wallet development services with Debut Infotech. Our security-focused designs and intuitive user experiences ensure tailored solutions for your blockchain project.'
};

export const CRYPTOCURRENCY_META_DATA: PageHeadMeta = {
    title: 'Cryptocurrency Exchange Development Company | Debut Infotech',
    img: cdnUrl('meta-images/nft-exchange-banner-img.jpg'),
    description:
        'Cryptocurrency Exchange Development services to build a secure, scalable platform. Partner with us to launch your exchange successfully.'
};

export const DECENTRALIZED_META_DATA: PageHeadMeta = {
    title: 'Decentralized Finance | DeFi Development | Debut Infotech',
    description:
        'Debut Infotech provides unmatchable decentralized finance - Defi development services for start-ups and businesses with the evolution of various Defi solutions.'
};

export const WHITE_LABEL_CRYPTO_DATA: PageHeadMeta = {
    title: 'White Label Crypto Wallet',
    img: cdnUrl('crypto-images/white-label-crypto-wallet.jpg'),
    description:
        "Debut Infotech's White Label Crypto Wallet provides a customizable, secure, and scalable platform to manage multiple cryptocurrencies, ready for quick business deployment"
};

export const DEFI_META_DATA: PageHeadMeta = {
    title: 'Decentralized Finance (DeFi) Development Services & Solutions',
    img: cdnUrl('meta-images/Defi-development-company.jpg'),
    description:
        'Get full-cycle DeFi development services for smart contracts, DEX, lending protocols, staking and tokenization — built for enterprise-grade security and scale.'
};

export const CRYPTO_BOT_META_DATA: PageHeadMeta = {
    title: 'Crypto Trading Bot Development Company',
    img: cdnUrl('meta-images/crypto-bot.jpg'),
    description: `Professional crypto trading bot development services. Custom algorithms, secure infrastructure, and expert support. Boost your trading strategy with our tailored solutions.`
};

export const CENTRALIZED_CRYPTOWALLET_META_DATA: PageHeadMeta = {
    title: 'Centralized Wallet Development Company',
    img: cdnUrl('meta-images/Centralized-Crypto-banner.jpg'),
    description:
        'Secure your crypto transactions with our Centralized Wallet Development Services. Scalable, reliable wallets designed for a seamless and secure digital experience.'
};

export const DECENTRALIZED_CRYPTO_WALLET_META_DATA: PageHeadMeta = {
    title: 'Decentralized Crypto Wallet Development Company',
    img: cdnUrl('decentralised/Decentralized-Crypto-Wallet-Development-Company.jpg'),
    description: `Unlock the power of decentralized finance with our expert crypto wallet development services. Secure, scalable, and customized solutions for your business.`
};

export const EWALLET_META_DATA: PageHeadMeta = {
    title: 'eWallet App Development Company | Digital Wallet Solutions',
    img: cdnUrl('E-wallet-images/Ewallet-App-Development-Company.jpg'),
    description: `Unlock the future of secure payments with our top-tier eWallet app development solutions. Trusted by leading brands. Get a free consultation today.`
};

export const WHITE_LABEL_META_DATA: PageHeadMeta = {
    title: 'White Label Crypto Exchange Development | Debut Infotech',
    description:
        'Launch your own branded crypto exchange in 6 weeks. Matching engine, KYC/AML, liquidity, mobile apps. Trusted by exchanges including OKX & NDAX. Book a free demo.',
    img: cdnUrl('meta-images/White-label-exchange-banner.jpg')
};

export const P2P_META_DATA = {
    title: 'P2P Exchange Development Company | P2P Exchange Software Development',
    description:
        'Elevate your crypto business with a trusted P2P exchange development partner delivering innovative and reliable blockchain solutions.',
    img: cdnUrl('P2P-crypto-exchange-dev/P2P-Crypto-Exchange-Development-Company.jpg')
};

export const BEP20_TOKEN_DEVELOPMENT = {
    title: 'Bep20 Token Development Company | Bep20 Token',
    description:
        'Leverage our BEP20 token development services to create secure, scalable, and customizable tokens on the Binance Smart Chain for your business needs.',
    img: cdnUrl('BEP-20/BEP20-Token-Development-Company.jpg')
};

export const MPC_CRYPTO_WALLET: PageHeadMeta = {
    title: 'MPC Wallet Development | MPC Crypto Wallet',
    description:
        'Unlock security with our MPC wallet development services. We protect your assets using MPC crypto wallets, offering advanced multi-party computation technology.',
    img: cdnUrl('MPC-wallet-dev/MPC-Crypto-Wallet-Development-Company.jpg')
};

export const TRON_WALLET_DEVELOPMENT_META_DATA: PageHeadMeta = {
    title: 'TRON Wallet Development Company | Secure TRX Wallet',
    img: cdnUrl('Tron-development-company/tron-wallet-development-company.jpg'),
    description:
        'Partner with our TRON Wallet development company to build a secure TRX wallet with advanced features for safe and seamless crypto management.'
};

export const CENTRALIZED_CRYPTO_EXCHANGE_META_DATA: PageHeadMeta = {
    title: 'Centralized Crypto Exchange Development',
    img: cdnUrl('Centralized-crypto-exchnage/Centralized-crypto-exchange-development.jpg'),
    description:
        'We offer expert Centralized Crypto Exchange Development services, focusing on secure, scalable platforms with enhanced liquidity and seamless user experience.'
};

export const WEB3_WALLET_DEVELOPMENT_META_DATA = {
    title: 'Web3 Wallet Development Services',
    img: cdnUrl('web3-wallet/web3-wallet-development-company.jpg'),
    description:
        'Build your secure Web3 wallet with our expert development services. We offer scalable, customizable solutions for seamless blockchain integration and user experience.'
};

export const ICO_DEVELOPMENT_COMPANY_META_DATA: PageHeadMeta = {
    title: 'ICO Development Company | ICO Development Services',
    img: cdnUrl('Ico-development/ICO-Development-Company.jpg'),
    description:
        'Debut Infotech is a leading ICO Development Company. Offering top-notch ICO development services to help you launch successful Initial Coin Offerings.'
};

export const DECENTRALIZED_EXCHANGE_COMPANY: PageHeadMeta = {
    title: 'DEX Development Company | DEX Development Services',
    img: cdnUrl('Decentralized-crypto-exchange/Decentralized-Exchange-Development-Company.jpg'),
    description:
        'Debut Infotech, a leading DEX Development Company, delivers secure, scalable, and innovative DEX development services for next-gen decentralized exchanges.'
};

export const HYBRID_CRYPTO_EXCHANGE_META_DATA: PageHeadMeta = {
    title: 'Hybrid Crypto Exchange Development Services',
    img: cdnUrl('hybrid-crypto-exchange/Hybrid-Crypto-Exchange-Development.jpg'),
    description:
        'Develop a hybrid crypto exchange platform combining centralized and decentralized features. Ensure secure trading, scalability, and user-centric experiences tailored to your needs.'
};

export const CRYPTO_DERIVATIVES_EXCHANGE_META: PageHeadMeta = {
    title: 'Crypto Derivatives Exchange Development Services',
    img: cdnUrl('CryptoDerivativesExchange/Crypto-Derivative-Exchange-Development.jpg'),
    description:
        'Develop a robust crypto derivatives exchange with advanced trading features, risk management tools, and secure architecture. Empower seamless futures and options trading for users.'
};

export const WHAT_IS_CRYPTOCURRENCY_EXCHANGE: PageHeadMeta = {
    title: 'What is a Cryptocurrency Exchange - Explained in Detail',
    description:
        'A cryptocurrency exchange is a digital platform for trading crypto assets. Learn how it works, its types, benefits, and key features. Start trading or building yours today.',
    img: cdnUrl('crypto-exchnage-pillarpage/Crypto-exchanges.jpg')
};

export const TOKEN_DEVELOPMENT_COMPANY: PageHeadMeta = {
    title: 'Crypto Token Development Company | Token Development Services',
    description:
        'Launch your own token with our professional crypto token development services. We deliver secure and scalable solutions for your blockchain needs.',
    img: cdnUrl('Token-development-company/Token-development-company.jpg')
};

export const OTC_CRYPTO_DEVELOPMENT: PageHeadMeta = {
    title: 'OTC Crypto Exchange Development Company',
    description:
        'Debut Infotech, a top OTC crypto exchange development company, offers secure, scalable platforms with advanced trading features and compliance-ready solutions.',
    img: cdnUrl('Token-development-company/Token-development-company.jpg')
};

export const MULTICURRENCY_WALLET_DEVELOPMENT: PageHeadMeta = {
    title: 'Multi Currency Wallet Development | Multi Currency Crypto Wallet',
    description:
        'We develop advanced multicurrency wallets to help you securely store and manage multiple cryptocurrencies. Get a customized solution for your crypto needs.',
    img: cdnUrl('Multicurrency-wallet-development/Multicurrency-Wallet-Development-Company.jpg')
};

export const CRYPTO_MARKET_SERVICE: PageHeadMeta = {
    title: 'Crypto Market Making Services',
    description:
        "Boost crypto liquidity and trading volumes with Debut Infotech's expert market-making services. Optimize token success with reliable liquidity solutions",
    img: cdnUrl('crypto-market-making/Crypto-market-making.jpg')
};

export const BITCOIN_WALLET_DEVELOPMENT: PageHeadMeta = {
    title: 'Bitcoin Wallet Development Company',
    description:
        'Build a secure, feature-rich Bitcoin wallet with advanced encryption, seamless transactions, and top-notch usability tailored to your unique business needs.',
    img: cdnUrl('bitcoin-development-wallet/Bitcoin-Wallet-Development-Company.jpg')
};

export const MEME_COIN_DEVELOPMENT: PageHeadMeta = {
    title: 'Meme Coin Development Company | Meme Coin Services',
    description:
        'Debut Infotech, a leading meme coin development company, offers end-to-end services to create secure, scalable meme tokens tailored to your business needs.',
    img: cdnUrl('Meme-coin-development/Meme-Coin-development-company.jpg')
};

export const MARGIN_TRADING_EXCHANGE: PageHeadMeta = {
    title: 'Crypto Margin Trading Exchange Development Services',
    description:
        'Build a powerful crypto margin trading exchange with advanced features, secure infrastructure, and seamless user experience. Partner with experts today!',
    img: cdnUrl('Margin-trading-exchange/Margin-Trading-Exchange-Development-Company.jpg')
};

export const STABLE_COIN_DEVELOPMENT_COMPANY: PageHeadMeta = {
    title: 'Stablecoin Development Company',
    description:
        'As a Leading stablecoin development company, we offer secure, scalable solutions for custom stablecoin creation, blockchain integration, and DeFi innovation.',
    img: cdnUrl('stablecoins-development/Stablecoin-Development.jpg')
};

export const IDO_DEVELOPMENT_SERVICE: PageHeadMeta = {
    title: 'IDO Development Company | Initial Dex Offering Services',
    description:
        'Launch your project with our IDO development company. We provide expert Initial Dex Offering services for secure, efficient, and successful token launches.',
    img: cdnUrl('IDO-development/IDO-Development-Company.jpg')
};

export const CRYPTO_PAYMENT_GATEWAY: PageHeadMeta = {
    title: 'Crypto Payment Gateway Development Company',
    description:
        'We build secure and scalable crypto payment gateways with our expert development services. Empower businesses with seamless cryptocurrency transactions today!',
    img: cdnUrl('Crypto-Payment-Gateway/Crypto-Payment-Gateway-Development-Company.jpg')
};

export const CRYPTO_LAUNCHPAD_DEVELOPMENT: PageHeadMeta = {
    title: 'Crypto Launchpad Development | Build Your Own Launchpad',
    description:
        'Get custom crypto launchpad development services to create robust platforms for token launches, crowdfunding, and blockchain-based project growth.',
    img: cdnUrl('Crypto-Launchpad-Development/Crypto-Launchpad-Development-Company.jpg')
};

export const WHITE_LABEL_AI_TOKEN: PageHeadMeta = {
    title: 'AI Token Development Company',
    description:
        'Get custom AI token development solutions tailored to your needs. Launch your AI-driven token seamlessly and stay ahead in the blockchain market.',
    img: cdnUrl('ai-crypto-token-development/White-Label-AI-Crypto-Token-Development.jpg')
};

export const ERC20_TOKEN_DEVELOPMENT = {
    title: 'ERC20 Token Development Company | Custom Token Solutions',
    description:
        'Launch secure ERC20 tokens with our expert development services. Get custom token solutions, smart contracts, and seamless blockchain integration.',
    img: cdnUrl('ERC-20/ERC-20-token-development-company.jpg')
};

export const STO_DEVELOPMENT_COMPANY: PageHeadMeta = {
    title: 'STO Development Company | Security Token Offering Services',
    description:
        'Launch your Security Token Offering with our STO development services. We ensure regulatory compliance, security, and seamless token issuance.',
    img: cdnUrl('STO-Development-Company/STO-Development-Company.jpg')
};

export const IEO_DEVELOPMENT_COMPANY: PageHeadMeta = {
    title: 'IEO Development Company | Initial Exchange Offering Services',
    description:
        'Launch your token with our expert IEO development services. We provide secure, efficient, and scalable initial exchange offering solutions.',
    img: cdnUrl('IEO-development-company/IEO-Development-Company.jpg')
};

export const DEFI_WALLET_DEVELOPMENT_COMPANY: PageHeadMeta = {
    title: 'DeFi Wallet Development Services',
    description:
        'Empower your crypto journey with expert DeFi wallet development. We craft secure, scalable blockchain solutions that enhance digital finance & innovate.',
    img: cdnUrl('DeFi-Wallet/DeFi-Wallet-Development-Company.jpg')
};

export const DEFI_LENDING_PLATFORM_DEVELOPMENT: PageHeadMeta = {
    title: 'DeFi Lending & Borrowing Platform Development Services',
    description:
        'Delivering enterprise-grade DeFi lending and borrowing platform development services tailored for crypto businesses focused on security, scalability, and compliance.',
    img: cdnUrl('DeFi-Lending-Platform-Development/DeFi-Lending-Platform-Development.jpg')
};

export const DEFI_STAKING_PLATFORM_DEVELOPMENT: PageHeadMeta = {
    title: 'DeFi Staking Platform Development Services',
    description:
        'Boost user engagement and maximize ROI with our DeFi staking platform development services tailored for secure, scalable, and customizable staking solutions.',
    img: cdnUrl('Defi-staking/DeFi-Staking%20-Platform-Development.jpg')
};

export const DEX_AGGREGATOR_META_DATA: PageHeadMeta = {
    title: 'DEX Aggregator Development Services',
    description:
        'Boost DeFi trading with our DEX aggregator development services. Ensure best prices, liquidity, and seamless swaps across multiple decentralized exchanges.',
    img: cdnUrl('dex-aggergator/DEX-Aggregator-Development-Services.jpg')
};

export const EQUITY_TOKEN_OFFERINGS: PageHeadMeta = {
    title: 'ETO Development Company | Equity Token Offering Services',
    description:
        'Partner with our leading ETO Development Company for seamless Equity Token Offering services, ensuring secure, compliant, and efficient tokenization solutions.',
    img: cdnUrl('Equity-Token-offering/Equity-Token-Offering-Development-Company.jpg')
};
